module.exports = __webpack_public_path__ + "static/media/DSCF6605.031daa1e.jpg";